export const columnHeadsNames = {
  'YEAR': 'Year',
  'QUARTER': 'Quarter',
  'MONTH': 'Month',
  'WEEK': 'Week',
  'DATE': 'Date',
  'AD_UNIT': 'Ad Unit',
  'SITE': 'Domain',
  'PRODUCT_TYPE': 'Product',
  'DEVICE': 'Device',
  'GEO': 'Country',
  'NET_REVENUE': 'Net Revenue ($)',
  'GROSS_REVENUE': 'Gross Revenue ($)',
  'GROSS_REVENUE_WITHOUT_DISCREPANCY': 'Gross Revenue Without Discrepancy ($)',
  'TOTAL_IMPRESSIONS': 'Total Impressions',
  'REFRESH_IMPRESSIONS': 'Refresh Impressions',
  'INITIAL_IMPRESSIONS': 'Initial Impressions',
  'PAGE_VIEWS': 'Page Views',
  'VIEWABILITY': 'Viewability',
  'AVG_CPM': 'CPM',
  'AVG_RPM': 'RPM',
  'INTEGRATION': 'Integration',
  'AD_REQUEST': 'Ad Request',
  'BID_RATE': 'Bid Rate',
  'WIN_RATE': 'Win Rate',
  'BID_REQUEST': 'Bid Request',
  'BID_RESPONSE': 'Bid Response',
  'WINNING_BID': 'Winning Bid',
  'VIDEO_VIEWED': 'Video Viewed',
  'VIDEO_START': 'Video Start',
  'VIDEO_Q1': 'Video Q1',
  'VIDEO_Q2': 'Video Q2',
  'VIDEO_Q3': 'Video Q3',
  'VIDEO_COMPLETE': 'Video Complete',
  'VIDEO_CLICK': 'Video Click'
};